function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Suspense } from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { changeSidebarTheme, changeSidebarType } from '../redux/layout/actions';
import * as layoutConstants from '../constants/layout';
import ThemeCustomizer from '../components/theme/ThemeCustomizer'; // code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52

const LeftSidebar = /*#__PURE__*/React.lazy(() => import('../components/theme/LeftSidebar'));
const Topbar = /*#__PURE__*/React.lazy(() => import('../components/theme/Topbar'));
const Footer = /*#__PURE__*/React.lazy(() => import('../components/theme/Footer'));
const RightSidebar = /*#__PURE__*/React.lazy(() => import('../components/theme/RightSidebar'));

// loading
const emptyLoading = () => /*#__PURE__*/React.createElement("div", null);

const loading = () => /*#__PURE__*/React.createElement("div", {
  className: "text-center"
});

class VerticalLayout extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "openLeftMenu", () => {
      if (document.body) document.body.classList.add('sidebar-enable');
    });

    _defineProperty(this, "updateDimensions", () => {
      // activate the condensed sidebar if smaller devices like ipad or tablet
      if (window.innerWidth >= 768 && window.innerWidth <= 1028) {
        this.props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED);
      } else if (window.innerWidth > 1028) {
        this.props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_FIXED);
      }
    });

    _defineProperty(this, "componentDidMount", () => {
      window.addEventListener("resize", this.updateDimensions.bind(this));
      this.props.changeSidebarTheme(layoutConstants.LEFT_SIDEBAR_THEME_DARK); // activate the condensed sidebar if smaller devices like ipad or tablet

      if (window.innerWidth >= 768 && window.innerWidth <= 1028) {
        this.props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED);
      }
    });

    this.openLeftMenu = this.openLeftMenu.bind(this);
  }
  /**
   * Opens the left menu - mobile
   */


  /**
   * Removes the listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    // get the child view which we would like to render
    const children = this.props.children || null;
    const isCondensed = this.props.layout.leftSideBarType === layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED;
    const isLight = this.props.layout.leftSideBarTheme === layoutConstants.LEFT_SIDEBAR_THEME_LIGHT;
    return /*#__PURE__*/React.createElement("div", {
      className: "app"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wrapper"
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: emptyLoading()
    }, /*#__PURE__*/React.createElement(LeftSidebar, _extends({}, this.props, {
      isCondensed: isCondensed,
      isLight: isLight,
      hideUserProfile: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "content-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: emptyLoading()
    }, /*#__PURE__*/React.createElement(Topbar, _extends({}, this.props, {
      openLeftMenuCallBack: this.openLeftMenu,
      hideLogo: true
    }))), /*#__PURE__*/React.createElement(Container, {
      fluid: true
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: loading()
    }, children))), /*#__PURE__*/React.createElement(Suspense, {
      fallback: emptyLoading()
    }, /*#__PURE__*/React.createElement(Footer, this.props)))), /*#__PURE__*/React.createElement(Suspense, {
      fallback: emptyLoading()
    }, /*#__PURE__*/React.createElement(RightSidebar, this.props, /*#__PURE__*/React.createElement(ThemeCustomizer, null))));
  }

}

const mapStateToProps = state => {
  return {
    layout: state.layout
  };
};

export default connect(mapStateToProps, {
  changeSidebarTheme,
  changeSidebarType
})(VerticalLayout);